import { render, staticRenderFns } from "./InvoiceOrderList.vue?vue&type=template&id=c5ef2c16&scoped=true"
import script from "./InvoiceOrderList.vue?vue&type=script&lang=js"
export * from "./InvoiceOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ef2c16",
  null
  
)

export default component.exports